import {ref, computed} from 'vue'
import {defineStore} from 'pinia'

export const useDomTrimmingStore = defineStore('domTrimming', () => {
	const replayTotalTimeInMs = ref(null)
	const isTrimming = ref(false)
	const activeTrimHandle = ref(null)
	const trimHandleXPositionInPx = ref(null)
	const trimmedStartTimeInMs = ref(0)
	const trimmedEndTimeInMs = ref(0)
	const onlyPlayTrimmedPart = ref(true)
	const domProgressBarPositionInPx = ref({
		width: null,
		left: null,
		right: null,
	})

	const trimStartAtSecond = computed(() => trimmedStartTimeInMs.value / 1000)
	const trimEndAtSecond = computed(() => trimmedEndTimeInMs.value / 1000)
	const trimStartPosition = computed(() => {
		if (!trimmedStartTimeInMs.value) return
		return (
			(trimmedStartTimeInMs.value / replayTotalTimeInMs.value) * domProgressBarPositionInPx.value.width +
			domProgressBarPositionInPx.value.left
		)
	})
	const trimEndPosition = computed(() => {
		if (!trimmedEndTimeInMs.value) return
		return (
			(trimmedEndTimeInMs.value / replayTotalTimeInMs.value) * domProgressBarPositionInPx.value.width +
			domProgressBarPositionInPx.value.left
		)
	})

	const resetStore = () => {
		replayTotalTimeInMs.value = null
		isTrimming.value = false
		activeTrimHandle.value = null
		trimHandleXPositionInPx.value = null
		trimmedStartTimeInMs.value = 0
		trimmedEndTimeInMs.value = 0
		onlyPlayTrimmedPart.value = true
		domProgressBarPositionInPx.value = {
			width: null,
			left: null,
			right: null,
		}
	}

	return {
		replayTotalTimeInMs,
		isTrimming,
		activeTrimHandle,
		trimHandleXPositionInPx,
		trimmedStartTimeInMs,
		trimmedEndTimeInMs,
		onlyPlayTrimmedPart,
		domProgressBarPositionInPx,
		trimStartAtSecond,
		trimEndAtSecond,
		trimStartPosition,
		trimEndPosition,
		resetStore,
	}
})
